import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";
import {
  setLastActivityTime,
  clearLastActivityTime,
} from "../../../utils/autoLogout";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    error: null,
    isAuthenticated: false,
    user: null, // Store user data from API
     jwtExpired: false, // Default jwtExpired flag
      moduleAccess: null, // Store user module access
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state) => {
      // Reset loading state on rehydration
      state.loading = false;
    });
  },
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload; // Store API response (user data)
      state.error = null;
      setLastActivityTime(); // Set initial activity time
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setModuleAccess: (state, action) => {
      state.moduleAccess = action.payload;
    },
    logout(state) {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
      clearLastActivityTime(); // Clear activity time on logout
    },
    clearError(state) {
      state.error = null;
    },
    setModuleAccess(state, action) {
      state.moduleAccess = action.payload;
    },
    setJwtExpired(state, action) {
      state.jwtExpired = action.payload; // true or false
    },
    // update user details
    updateUserStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateUserSuccess(state, action) {
      state.loading = false;
      state.user = {
        ...state.user,
        data: {
          ...state.user.data,
          ...action.payload,
        },
      };
    },
    updateUserFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setUserLocale(state, action) {
      const { ats, workforce, benchsales } = action.payload;
      if (ats) {
        state.user.data.locale.ats = ats;
      }
      if (workforce) {
        state.user.data.locale.workforce = workforce;
      }
      if (benchsales) {
        state.user.data.locale.benchsales = benchsales;
      }
    },
    setOrganizationLocaleType(state, action) {
      if (state.user?.data?.organizationId?.locale) {
        state.user.data.organizationId.locale.default = action.payload;
      }
    },
    setRoleLocale(state, action) {
      const { locale } = action.payload;

      if (!state.user || !state.user.data) return;

      if (!state.user.data.role) {
        state.user.data.role = {};
      }

      state.user.data.role.locale = locale;
    },
    setOrganizationLocale(state, action) {
      const locale = action.payload;

      if (!state.user || !state.user.data) return;

      if (!state.user.data.organizationId) {
        state.user.data.organizationId = {};
      }

      if (!state.user.data.organizationId.locale) {
        state.user.data.organizationId.locale = {};
      }

      state.user.data.organizationId.locale = {
        ...state.user.data.organizationId.locale,
        ...locale,
      };
    },
    updateOrganizationSuccess(state, action) {
      if (state.user?.data?.organizationId) {
        state.user.data.organizationId = {
          ...state.user.data.organizationId,
          ...action.payload,
        };
      }
    }

  },
});

export default authSlice.reducer;
export const { loginStart, loginSuccess, loginFailure, logout, clearError,setJwtExpired,setModuleAccess,updateUserStart,updateUserSuccess,updateUserFailure,setUserLocale,setOrganizationLocaleType,setRoleLocale,setOrganizationLocale, updateOrganizationSuccess } =
  authSlice.actions;
